﻿'use strict';

/**
 * @ngdoc directive
 * @name ntmApp.directive:gridMultiselect
 * @description
 * # gridMultiselect
 */
angular.module('ntmApp')
  .directive('gridMultiselect', function () {
      return {
          restrict: 'E',
          templateUrl : function(elem,attrs) {
              return attrs.templateUrl || 'ng1/src/directives/templates/gridMultiselectFilter.html';
          }
      };
  });